import React from 'react';
import { useAppDispatch } from '@wfp-root-app/store/store';

import { ActionCreators, ExtendedManager } from './managers';
import PermissionsFiles from '../permissions-files/PermissionsFiles';
import { ManagerPermission } from '../permission-profiles/permission';

interface Props {
    manager: ExtendedManager;
}

function ManagerPermissionsFiles({ manager }: Props) {
    const dispatch = useAppDispatch();

    const uploadPermissionsFile = (userId: string, file: File) => {
        return dispatch(ActionCreators.uploadPermissionsFile(userId, file));
    };

    return (
        <PermissionsFiles
            permissionsFiles={manager.permissionsFiles}
            requiredPermission={[ManagerPermission.managersManagementPark, ManagerPermission.managersManagementPost]}
            uploadPermissionsFile={uploadPermissionsFile}
            userId={manager.id}
        />
    );
}

export { ManagerPermissionsFiles };
